import React, { useState, useCallback } from 'react';
import PropTypes from 'prop-types';

import { PageSubTitle } from 'components/common/Elements/Elements';
import InputWithUnmaunt from 'components/common/forms/InputWithUnmaunt/InputWithUnmaunt';
import Messages from '../Messages/Messages';

import { filterForArrValues } from 'utils/common';

import classes from './AdditionalContent.module.scss';

const AdditionalContent = ({ data }) => {
  const [find, setFind] = useState('');
  const handleFind = e => {
    setFind(e.target.value);
  };
  const onClearFind = useCallback(() => {
    setFind('');
  }, []);

  return (
    <>
      <PageSubTitle
        title={`${data.ticketName}`}
        className={classes.title}
        classNameHeading={classes.heading}
        size={2}
      />

      <InputWithUnmaunt
        placeholder="Message"
        value={find}
        onChange={handleFind}
        onClearSearch={onClearFind}
        unmauntFunc={onClearFind}
        className={classes.input}
        timeDebounce={0}
      />

      <ul className={classes.children}>
        {filterForArrValues(data.messages, ['message'], find).map(
          (item, index) => (
            <li key={`${item.updatedAt}+${index}`} className={classes.item}>
              <Messages data={item} />
            </li>
          )
        )}
      </ul>
    </>
  );
};

AdditionalContent.propTypes = {
  data: PropTypes.object.isRequired
};

export default AdditionalContent;
